<template>
    <div v-swiper:mySwiper="swiperOptions" class="swiper-container swiper-topBanner">
        <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="item in bannerList" :key="item.id">
                <div class="travelDetail-bannerPic">
                    <img :src="item.imgUrl">
                </div>
            </div>
        </div>
        <div class="swiper-pagination" v-if="bannerList.length > 1"></div>
    </div>
</template>

<script>
    import { directive } from 'vue-awesome-swiper'
    import 'swiper/css/swiper.css'
    export default {
        name: 'TravelNoteDetailBanner',
        directives: {
            swiper: directive
        },
        props: {
            bannerList: {
                type: Array,
                default: function () {}
            }
        },
        data () {
            return {
                swiperOptions: {
                    loop: true,
                    pagination: {
                        el: '.swiper-pagination'
                    }
                }
            }
        },
        methods: {}
    }
</script>

<style lang="less" scoped>
    /**** banner ****/
    .travelDetail-bannerPic {
        width: 100%;
        overflow: hidden;
        &>img {
            width: 100%;
        }
    }
</style>
